// Values must match BE enums: SampleMetricsTimeRange, SampleMetricsGranularity, SampleMetricsStackBy
export enum SampleMetricsTimeRange {
  Ytd = 0,
  Last12Months = 1,
  Last24Months = 2,
  Last3Years = 3,
  Last5Years = 4,
  Custom = 5,
  AllDates = 6,
}

export enum SampleMetricsGranularity {
  Monthly = 0,
  Quarterly = 1,
  Yearly = 2
}

export enum SampleMetricsStackBy {
  Agent = 0,
  Seg = 1
}
